import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

export class AdapterDayjsBuddhist extends AdapterDayjs {
    // Override format function to adjust year
    formatByString = (date: Dayjs, formatString: string): string => {
      const adjustedDate = date.set('year', date.year() + 543); // Convert to Buddhist Year
      return adjustedDate.format(formatString);
    }
  
    // Parse function to convert Buddhist year back to Gregorian
    parse = (value: string, formatString: string): Dayjs | null => {
      const parsed = dayjs(value, formatString);
      return parsed.isValid() ? parsed.set('year', parsed.year() - 543) : null;
    }
  }